import domain from './domain';

export const isModeAdmin = process.env.REACT_APP_MODE === 'admin';
export const isModeMerchant = process.env.REACT_APP_MODE === 'merchant';